export { default as InformationalSection } from './InformationalSection'
export { default as SubscriptionSection } from './SubscriptionSection'



// WEBPACK FOOTER //
// ./src/components/sections/index.js